<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("lbl.pelletizing.qualityResult.selfTestPelletizingGriList") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{path:'/prd/selfTestPelletizingGri', query:{id: selfTestId}}">
              <span>{{$t('tlt.pelletizing.selfTestPelletizingGri')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div id="selfTestPelletizingGriTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table entity="selfTestPelletizingGri" :singleChoice="true"   inline-actions-disabled disableDelete></mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { filterFields } from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingGri";
import { gridFields } from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingGri";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "selfTestPelletizingGri/getField",
  mutationType: "selfTestPelletizingGri/updateField"
});

export default {
  name: "selfTestPelletizingGriList",
  data() {
    return {};
  },
  components: { MmfTable, MmfDatepicker },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(filterFields),

    ...mapState("selfTestPelletizingGri", {
      rows: state => state.rows,
      entity: state => state.entity,
      baseModuleUrl: state => state.baseModuleUrl,
        selfTestId: state => state.selfTestId
    })
  },
  methods: {
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter", "MMFNew"]),
      ...mapActions("selfTestPelletizingGri", ["Load"])
  },
  created() {
    this.Load(this.$route.query.id);
//     const context = this.$store;
//  const id = this.$route.query.id; // 从当前的路由中获取参数 id
//     const baseModuleUrl = this.baseModuleUrl;

//     context.dispatch("selfTestPelletizingGri/updateSelfTestId", id);
//     context
//       .dispatch("api/get", {
//         url:
//           baseModuleUrl +
//           "/selfTestPelletizingGri/findBySelfTestPelletizing/" +
//           id
//       })
//       .then(response => {
//         context.commit("selfTestPelletizingGri" + "/setRows", response);
//       });
  }
};
</script>
